import { forwardRef, type HTMLAttributes } from 'react';

import { Checkbox } from '../../../atoms';
import { useVirtualMultiselectItem } from '../contexts/item.context';

export const VirtualMultiselectCheckbox = forwardRef<
  HTMLButtonElement,
  HTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => {
  const { id, selected, disabled } = useVirtualMultiselectItem();

  return (
    <Checkbox
      ref={ref}
      id={id}
      checked={selected}
      disabled={disabled}
      className={className}
      {...props}
    />
  );
});
